import { useEffect, useMemo, useRef, useState, useContext } from "react";
import { getCategoryProductList, getMenu } from "../services/apiService";
import "../styles/categorysilder.css";
import "../styles/CategoriesPage.css";
import { useNavigate } from "react-router-dom";
import noimage from "../assets/noimage.webp";
import {
  AddItemToWishList,
  AddItemToCart,
  DeleteFromWishList,
  getProductQty,
} from "../services/Cart";
import { Notifyed } from "../services/Auth";
import { showSnackbar } from "../comopnents/snackbar";
import LoadingSpinner from "../comopnents/LoadingSpinner";
// import { Notifyed } from "../services/Cart";
import { CartContext } from "../contextApi/CartContext";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import CartQuantityControl from "../comopnents/CartQuantityControl";
import PurchaseOptionsModal from "../comopnents/PurchaseOptionsModal";
import { useAuthGuard } from "../comopnents/useAuthGuard";
import {
  buildCartPurchaseData,
  buildEnhancedPurchaseData,
  getMinimumPurchaseQuantity,
  getMinOrderQty,
  getPurchaseQuantityStep,
  getSavedCartPurchaseData,
  shouldShowPurchaseModal,
} from "../utils/purchaseOptions";
import { isOutOfStock } from "../utils/stock";
import { getProductDisplayModel } from "../utils/productCard";
import { FaStar } from "react-icons/fa";



const CategorySlider = () => {
  const isLoggedIn = Boolean(localStorage.getItem("token"));
  const { requireAuth, authModal } = useAuthGuard();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  const [viewAll, setViewAll] = useState(false);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [wishlistedProducts, setWishlistedProducts] = useState({});
  const [wishlist, setWishlist] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [pendingPurchaseProduct, setPendingPurchaseProduct] = useState(null);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= 768 : false,
  );

  const [cartItems, setCartItems] = useState([]);
  const {
    addToCart,
    deleteCartItems,
    itemList,
    updateQty,
    setCartQty,
    userId,
    removeFromCart,
  } = useContext(CartContext);
  const sliderRef = useRef(null);
  const navigate = useNavigate();


  const handleAddToCart = async (product, purchaseType, couponData = null) => {
    if (isOutOfStock(product)) {
      await handleNotifyMe(product.productid || product.dtl?.[0]?.productid);
      return;
    }

    const purchaseData = buildEnhancedPurchaseData(product, purchaseType, couponData);
    const productId = purchaseData.productId;

    if (!requireAuth(() => handleAddToCart(product, purchaseType))) return;

    const userId = localStorage.getItem("userId");

    try {
      const payload = {
        customerid: userId,
        productid: productId,
        qty: purchaseData.quantity,
        stock: product.stock || product.dtl?.[0]?.stock,
      };
      await AddItemToCart(payload); // API call
      addToCart(productId, purchaseData.quantity, purchaseData); // Update frontend cart state
      showSnackbar("success", "Item added to cart!");
    } catch (error) {
      console.error(
        "Add to cart error:",
        error.response?.data || error.message,
      );
      showSnackbar("error", "Failed to add item to cart!");
    }
  };

  const openPurchaseModal = (product) => {
    if (!shouldShowPurchaseModal(product)) {
      handleAddToCart(product, "piece");
      return;
    }
    setPendingPurchaseProduct(product);
    setShowModal(true);
  };

  const confirmPurchaseType = async (purchaseType, couponData) => {
    if (!pendingPurchaseProduct) return;

    await handleAddToCart(pendingPurchaseProduct, purchaseType, couponData);
    setShowModal(false);
    setPendingPurchaseProduct(null);
  };

  const AddToWishList = async (productid) => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        if (!requireAuth(() => AddToWishList(productid))) return;
        return;
      }

      if (wishlistItems.includes(productid)) return;

      await AddItemToWishList({ productid, customerid: userId });
      setWishlistItems((prev) => [...prev, productid]);
      showSnackbar("success", "Added to wishlist!");
    } catch (error) {
      console.error("Wishlist error:", error.response?.data || error.message);
    }
  };

  const handleDeleteWishList = async (productid) => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      await DeleteFromWishList({ customerid: userId, productid });
      setWishlist((prev) => ({ ...prev, [productid]: false }));
    } catch (err) {
      console.error("Error deleting from wishlist:", err);
    }
  };


  const handleNotifyMe = async (productid) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      if (!requireAuth(() => handleNotifyMe(productid))) return;
      return;
    }
    try {
      await Notifyed({ customerid: userId, productid });
      showSnackbar("success", "We will notify you when product is available");
    } catch (error) {
      console.error("Notify me error:", error.response?.data || error.message);
      showSnackbar("error", "Failed to register notify request");
    }
  };

  const handleCartQtyChange = async (productId, newQty) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      if (!requireAuth(() => handleCartQtyChange(productId, newQty))) return;
      return;
    }

    try {
      await getProductQty({ user_id: userId, productid: productId, qty: newQty });
      setCartQty(productId, newQty);
    } catch (error) {
      console.error("API Error:", error?.message || error);
      showSnackbar("error", "Failed to update quantity");
    }
  };


  useEffect(() => {
    fetchMenu();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchMenu = async () => {
    try {
      setLoading(true);
      const data = await getMenu();
      const menuCategories = Array.isArray(data?.Data) ? data.Data : [];
      setCategories(menuCategories);

      if (menuCategories.length) {
        setSelectedCategory("Welding Machine");
      }
    } catch (error) {
      console.error("Failed to fetch menu:", error);
    } finally {
      setLoading(false);
    }
  };

  const scrollLeft = () => {
    if (sliderRef.current) {
      const cardWidth = 220; // Width of each card including gap
      sliderRef.current.scrollBy({ left: -cardWidth * 2, behavior: "smooth" });
    }
  };
  //

  const scrollRight = () => {
    if (sliderRef.current) {
      const cardWidth = 220; // Width of each card including gap
      sliderRef.current.scrollBy({ left: cardWidth * 2, behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (!selectedCategory && !viewAll) return;

    const fetchCategoryProducts = async () => {
      try {
        setProductsLoading(true);

        if (viewAll) {
          const menu = await getMenu();
          const menuCategories = Array.isArray(menu?.Data) ? menu.Data : [];
          const categoryResponses = await Promise.all(
            menuCategories.map((categoryItem) =>
              getCategoryProductList(categoryItem.category).catch(() => ({ data: [] })),
            ),
          );
          const allProducts = categoryResponses.flatMap((response) =>
            Array.isArray(response?.data) ? response.data : [],
          );

          // Welding Machine items first
          allProducts.sort((a, b) => {
            const aIsWelding = a?.category === "Welding Machine";
            const bIsWelding = b?.category === "Welding Machine";
            if (aIsWelding && !bIsWelding) return -1;
            if (!aIsWelding && bIsWelding) return 1;
            return 0;
          });

          const seenProductKeys = new Set();
          const uniqueProducts = allProducts.filter((product, index) => {
            const productKey =
              product?.productid ||
              product?.feeproductid ||
              product?.modelno ||
              `${product?.category || "category"}-${product?.subcategory || "subcategory"}-${index}`;
            if (seenProductKeys.has(productKey)) return false;
            seenProductKeys.add(productKey);
            return true;
          });
          setProducts(uniqueProducts);
        } else {
          const data = await getCategoryProductList(selectedCategory);
          setProducts(Array.isArray(data?.data) ? data.data : []);
        }
      } catch (error) {
        console.error("Failed to fetch category products:", error);
        setProducts([]);
      } finally {
        setProductsLoading(false);
      }
    };

    fetchCategoryProducts();
  }, [selectedCategory, viewAll]);
  // useEffect(() => {
  //   if (!selectedCategory && !viewAll) return;

  //   const fetchCategoryProducts = async () => {
  //     try {
  //       setProductsLoading(true);

  //       if (viewAll) {
  //         const menu = await getMenu();
  //         const menuCategories = Array.isArray(menu?.Data) ? menu.Data : [];
  //         const categoryResponses = await Promise.all(
  //           menuCategories.map((categoryItem) =>
  //             getCategoryProductList(categoryItem.category).catch(() => ({ data: [] })),
  //           ),
  //         );
  //         const allProducts = categoryResponses.flatMap((response) =>
  //           Array.isArray(response?.data) ? response.data : [],
  //         );
  //         const seenProductKeys = new Set();
  //         const uniqueProducts = allProducts.filter((product, index) => {
  //           const productKey =
  //             product?.productid ||
  //             product?.feeproductid ||
  //             product?.modelno ||
  //             `${product?.category || "category"}-${product?.subcategory || "subcategory"}-${index}`;
  //           if (seenProductKeys.has(productKey)) return false;
  //           seenProductKeys.add(productKey);
  //           return true;
  //         });
  //         setProducts(uniqueProducts);
  //       } else {
  //         const data = await getCategoryProductList(selectedCategory);
  //         setProducts(Array.isArray(data?.data) ? data.data : []);
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch category products:", error);
  //       setProducts([]);
  //     } finally {
  //       setProductsLoading(false);
  //     }
  //   };

  //   fetchCategoryProducts();
  // }, [selectedCategory, viewAll]);

  const getProductImage = (product) =>
    product?.image1 ||
    product?.image2 ||
    product?.image3 ||
    product?.dtl?.[0]?.image1 ||
    noimage;


  const getProductPricing = (product) => {
    const mrp = Number(product?.mrp || product?.dtl?.[0]?.mrp || 0);

    const discount = Number(product?.discount || product?.dtl?.[0]?.discount || 0);

    if (!mrp) return null;

    return {
      mrp,
      netrate: Number(product?.netrate || product?.dtl?.[0]?.netrate || 0),
      finalPrice: discount ? Math.round(mrp - (mrp * discount) / 100) : mrp,
    };
  };

  const getAverageRating = (product) => {
    const ratings = product?.rating;
    if (!ratings || !Array.isArray(ratings) || ratings.length === 0) return null;
    const totalWeight = ratings.reduce((sum, r) => sum + (r.rating || 0) * (r.zcount || 0), 0);
    const totalCount = ratings.reduce((sum, r) => sum + (r.zcount || 0), 0);
    return totalCount > 0 ? (totalWeight / totalCount).toFixed(1) : null;
  };

  return (
    <div className="category-slider-section">
      <h2 className="section-titlee">CATEGORIES</h2>

      <div className="slider-container">
        <button className="slider-arrow left-arrow" onClick={scrollLeft}>
          {/* <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg> */}
        </button>


        <div className="categories-slider" ref={sliderRef}>
          {loading ? (
            <LoadingSpinner text="Loading categories..." />
          ) : (
            <>
              {categories.map((item, index) => (
                <button
                  type="button"
                  className={`category-item ${selectedCategory === item.category ? "active" : ""}`}
                  key={index}
                  onClick={() => {
                    setSelectedCategory(item.category);
                    setViewAll(false);
                  }}
                >
                  {/* <div className="category-image-wrapper">
                    <img
                      src={
                        item?.Images?.[0]?.imageurl || "/api/placeholder/180/120"
                      }
                      alt={item.category}
                      className="category-image"
                      onError={(e) => {
                        e.target.src = "/api/placeholder/180/120";
                      }}
                    />
                  </div> */}
                  <span className="category-title">{item.category}</span>
                </button>
              ))}

              {isMobile && (
                <button
                  type="button"
                  className={`category-item category-view-all-btn ${viewAll ? "active" : ""}`}
                  onClick={() => {
                    setViewAll(true);
                    setSelectedCategory("");
                  }}
                >
                  <span className="category-title">View All</span>
                </button>
              )}
            </>
          )}
        </div>

        {!isMobile && (
          <button
            type="button"
            className={`category-view-all-btn ${viewAll ? "active" : ""}`}
            onClick={() => {
              setViewAll(true);
              setSelectedCategory("");
            }}
          >
            View All
          </button>
        )}


      </div>

      <div className="category-products-home">
        {/* <div className="category-products-home-header">
          <h3>{selectedCategory || "Category"} Products</h3>
          {selectedCategory && (
            <button
              type="button"
              onClick={() =>
                navigate(
                  `/shopbycategory?category=${encodeURIComponent(selectedCategory)}`,
                )
              }
            >
              View All
            </button>
          )}
        </div> */}

        {productsLoading ? (
          <LoadingSpinner text="Loading products..." />
        ) : products.length ? (
          <div className="category-products-home-grid">
            {products
              .filter((product) => Number(product?.active) !== 0)
              .map((product) => {
                const pricing = getProductPricing(product);
                const qty =
                  itemList.find(
                    (item) => String(item.productId) === String(product.productid),
                  )?.count || 0;
                const minorderqty = product.minorderqty || product.dtl?.[0]?.minorderqty || 1;
                const discount = Number(product?.discount || product?.dtl?.[0]?.discount || 0);

                const stock = product.stock || product.dtl?.[0]?.stock || 0;
                const netrate = Number(product.netrate || product.dtl?.[0]?.netrate || 0);
                const savedPurchaseData = getSavedCartPurchaseData(product.productid);
                const purchaseType = savedPurchaseData?.purchaseType || "piece";

                return (
                  <div
                    className="category-product-card category-products-home-card"
                    key={product.productid || product.feeproductid || product.modelno}
                  >

                    <button
                      type="button"
                      className="category-product-image-btn category-products-home-image-btn"
                      onClick={() =>
                        navigate(`/productdetail?productid=${product.productid}`)
                      }
                    >
                      <div
                        className="category-products-home-actions"
                      >
                        {isLoggedIn && ((stock > 0 && netrate > 0) || Number(product.discount || 0) > 0) && (
                          <span
                            className="discount-badge"
                          >
                            {stock > 0 && netrate > 0
                              ? "Netrate"
                              : `${product.discount}% OFF`}
                          </span>
                        )}

                        <button
                          className="wishlist-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            setWishlist((prev) => {
                              const updated = !prev[product.productid];

                              if (updated) {
                                AddToWishList(product.productid);
                              } else {
                                handleDeleteWishList(product.productid);
                              }

                              return {
                                ...prev,
                                [product.productid]: updated,
                              };
                            });
                          }}
                          aria-label={
                            wishlist[product.productid]
                              ? "Remove from wishlist"
                              : "Add to wishlist"
                          }
                          type="button"
                        >
                          {wishlist[product.productid] ? (
                            <FaHeart color="#ff4d4f" size={18} />
                          ) : (
                            <FaRegHeart size={18} />
                          )}
                        </button>
                      </div>
                      <img
                        src={getProductImage(product)}
                        alt={getProductDisplayModel(product)}
                        onError={(event) => {
                          event.currentTarget.src = noimage;
                        }}
                      />
                    </button>
                    <div className="card-brand-row">
                      <span>{product.brand || selectedCategory}</span>

                      {getAverageRating(product) && (
                        <span style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                          <FaStar color="gold" size={18} />
                          <span style={{ fontSize: "15px", fontWeight: "700", color: "#555" }}>
                            {getAverageRating(product)}
                          </span>
                        </span>
                      )}
                    </div>

                    {/* <strong className="card-model-name">
                    {(product.modelno || product.displaymodelno)?.toUpperCase()}
                  </strong> */}
                    <strong className="card-model-name">
                      {getProductDisplayModel(product).toUpperCase()}
                    </strong>

                    <small className="card-category">
                      {(product.subcategory || product.category)
                        ?.charAt(0)
                        .toUpperCase() +
                        (product.subcategory || product.category)
                          ?.slice(1)
                          .toLowerCase()}
                    </small>

                    <small>Min order Qty : {product.minorderqty}</small>

                    <p className="category-product-price-row category-products-home-price-row">
                      {Number(product?.mrp || 0) <= 0 ? (
                        <span className="category-product-price">
                          MRP : Coming Soon
                        </span>
                      ) : (
                        <>
                          {!isLoggedIn && (
                            <span
                              className="category-products-home-mrp"
                            >
                              MRP ₹{Number(product.mrp).toFixed(2)}
                            </span>
                          )}

                          {isLoggedIn && (
                            <>

                             


                              <span
                                className="category-products-home-mrp"
                              >
                                MRP ₹{Number(product.mrp).toFixed(2)}
                              </span>

                               <span
                                className="category-products-home-price"
                                  style={{
                                      color: "#005487",
                                      fontSize: "16px",
                                      fontWeight: "600",
                                      display: "block",
                                    }}
                              >
                                Rs.{" "}
                                {Number(
                                  pricing?.netrate > 0
                                    ? pricing.netrate
                                    : pricing?.finalPrice || 0
                                ).toFixed(2)}
                              </span>

                            </>
                          )}
                        </>
                      )}
                    </p>

                    <div className="card-action-area">
                      {stock <= 0 ? (
                        <button
                          className="card-action-button notify-button"
                          onClick={() => handleNotifyMe(product.productid)}
                        >
                          Notify Me
                        </button>
                      ) : qty > 0 ? (
                        <CartQuantityControl
                          qty={qty}
                          minQty={getMinimumPurchaseQuantity(product, purchaseType)}
                          step={purchaseType !== "piece" ? getPurchaseQuantityStep(product, purchaseType) : undefined}
                          stock={stock}
                          purchaseType={purchaseType}
                          product={product}
                          onChange={(newQty) =>
                            handleCartQtyChange(product.productid, newQty)
                          }
                          className="qty-box"
                        />
                      ) : (
                        <button
                          className="card-action-button add-cart-button"
                          onClick={() => openPurchaseModal(product)}
                        >
                          Add to Cart
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="loading-text">{viewAll ? "No products found." : "No products found for this category."}</div>
        )}
      </div>

      {authModal}

      <PurchaseOptionsModal
        isOpen={showModal}
        product={pendingPurchaseProduct}
        onClose={() => {
          setShowModal(false);
          setPendingPurchaseProduct(null);
        }}
        onConfirm={confirmPurchaseType}
      />
    </div>
  );
};

export default CategorySlider;
